import React from "react";

import { IconProps } from "../types";

import { Path } from "./Path";

export const Label = ({ className, color }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    className={className}
  >
    <Path
      color={color}
      d="M21.41 12.0312L12.41 3.03117C12.05 2.67117 11.55 2.45117 11 2.45117H4C2.9 2.45117 2 3.35117 2 4.45117V11.4512C2 12.0012 2.22 12.5012 2.59 12.8712L11.59 21.8712C11.95 22.2312 12.45 22.4512 13 22.4512C13.55 22.4512 14.05 22.2312 14.41 21.8612L21.41 14.8612C21.78 14.5012 22 14.0012 22 13.4512C22 12.9012 21.77 12.3912 21.41 12.0312ZM5.5 7.45117C4.67 7.45117 4 6.78117 4 5.95117C4 5.12117 4.67 4.45117 5.5 4.45117C6.33 4.45117 7 5.12117 7 5.95117C7 6.78117 6.33 7.45117 5.5 7.45117Z"
    />
  </svg>
);
